/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="88.96"
        height="95.58"
        viewBox="0 0 88.96 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M87.67 20.93a1.25 1.25 0 0 1 0 2.5c-5.58 0-8.7 1.12-10.18 3.17a6.87 6.87 0 0 0-1.23 3.63v1.06a1.41 1.41 0 0 0 0 .29v2.39a1.25 1.25 0 0 1-2.5 0v-3.29a9.56 9.56 0 0 1 1.75-5.54c2.03-2.85 5.9-4.21 12.16-4.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M42.19 0a34 34 0 0 1 34 33.41v6.53a16.18 16.18 0 0 1-15.8 16.12H16.12A16.16 16.16 0 0 1 0 40.29v-6.28a1.25 1.25 0 0 1 1.12-1.24h39.82V1.29A1.23 1.23 0 0 1 42.06.05ZM2.5 35.22v4.72a13.66 13.66 0 0 0 13.31 13.62H60a13.67 13.67 0 0 0 13.67-13.27v-5ZM43.44 2.5v30.2h30.23v-.31A31.48 31.48 0 0 0 43.77 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M10.18 53.29a1.24 1.24 0 0 1 1.62-.4l.12.07 43.82 29.69a1.25 1.25 0 0 1-1.29 2.14l-.11-.07-43.83-29.69a1.24 1.24 0 0 1-.33-1.73Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M54.67 71.22A12.18 12.18 0 1 0 66.85 83.4a12.18 12.18 0 0 0-12.18-12.18Zm0 2.5a9.68 9.68 0 1 1-9.65 9.71 9.68 9.68 0 0 1 9.65-9.71Z"/>
        <path
          fill="#fff"
          d="M64.1 52.99a1.253 1.253 0 0 1 1.51 2l-.11.08L21.76 84.7a1.26 1.26 0 0 1-1.52-2l.11-.08Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M21.44 71.22A12.18 12.18 0 1 0 33.67 83.4a12.18 12.18 0 0 0-12.18-12.18Zm0 2.5a9.68 9.68 0 1 1-9.68 9.68 9.69 9.69 0 0 1 9.68-9.68Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'BabyBuggyIcon';

export default Icon;
